/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListRoles } from "../funcs/accessListRoles.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRolesResult } from "../models/components/listrolesresult.js";
import {
  ListRolesRequest,
  ListRolesSecurity,
} from "../models/operations/listroles.js";
import { unwrapAsync } from "../types/fp.js";
export type RolesQueryData = ListRolesResult;

export function prefetchRoles(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRolesRequest | undefined,
  security?: ListRolesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRolesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRolesQuery(
  client$: GramCore,
  request?: ListRolesRequest | undefined,
  security?: ListRolesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RolesQueryData>;
} {
  return {
    queryKey: queryKeyRoles({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function rolesQueryFn(ctx): Promise<RolesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListRoles(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRoles(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listRoles", parameters];
}
